// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ZE-z","hovered":"_E-z","hoverImage":"aF-z","mainImage":"bF-z","imageNoBackground":"cF-z","fullSizeImage":"dF-z"};